// extracted by mini-css-extract-plugin
export default {"box":"Testimonials_box__Md7rh","data":"Testimonials_data__L1-PV","heading":"Testimonials_heading__4vfuT","text":"Testimonials_text__Zko-N"};